import { App } from "vue";
import { createRouter, createWebHashHistory, createWebHistory } from "vue-router";
import { AppRouting } from "../app.routing";
import { setupRouterGuards,setupRouterAuthentication } from "./setup/setupRouterGuards";
import store from "@/store";

const router = createRouter({
  history: createWebHistory(""),
  routes: AppRouting,
});


export function setupRouter(app: App) {
  app.use(router);
  setupRouterGuards(router, app);
  setupRouterAuthentication(router, app);
}
export default router;
